import script from "./AppHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppHome.vue?vue&type=script&setup=true&lang=ts"

import "./AppHome.vue?vue&type=style&index=0&id=26b42ed6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b42ed6"]])

export default __exports__